<template>
<div class="columns">
    <div class="column is-full has-text-centered" style="margin-top: 150px;">
        <img src="/loader-dark.svg">
    </div>
</div>
</template>

<script>
export default {
    mounted() {
        this.deleteToken();
        this.$router.push({ name: 'landing' });
    },

    methods: {
        deleteToken() {
            localStorage.removeItem('authenticationToken');
        },
    },
}
</script>
